var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({staticClass:"has-text-white has-text-weight-bold btn3d to-click",class:( _obj = {}, _obj['btn-' + _vm.color] = true, _obj['btn-' + _vm.size] = true, _obj['block'] =  _vm.block, _obj['btn-disabled'] =  _vm.active, _obj )},'button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }